'use strict';

const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IntervalPickerController=class IntervalPickerController{
static get $inject(){
return['$scope','$timeout','$element','intervalService','timeZoneService','elementService','$document'];
}

constructor($scope,$timeout,$element,intervalService,timeZoneService,elementService,$document){
if(!_.exists(this.interval)){
return;
}
this._$scope=$scope;
this._$timeout=$timeout;
this._intervalService=intervalService;
this._elementService=elementService;
this._localTimeZone=timeZoneService.localTimeZone;
this._inputDateFormat='MMM DD YYYY';

this._mainButtonElement=$element[0].querySelector('#select-interval');
this._mainDropdownElement=$element[0].querySelector('#interval-dropdown');

this._startPickerInputElement=$element[0].querySelector('#start-picker');
this._startPickerCalendarContainer=$element[0].querySelector('#start-picker-calendar');

this._endPickerInputElement=$element[0].querySelector('#end-picker');
this._endPickerCalendarContainer=$element[0].querySelector('#end-picker-calendar');

if(!_.exists(this.startPicker)){
this.startPicker=new Pikaday({
field:this._startPickerInputElement,
container:this._startPickerCalendarContainer,
format:this._inputDateFormat,
trigger:this._mainDropdownElement,
onSelect:newStart=>this._updateCustomStartTime(newStart),
onClose:()=>this.startPicker.show(),
onDraw:()=>this._highlightCustomIntervalInCalendars()});

}

if(!_.exists(this.endPicker)){
this.endPicker=new Pikaday({
field:this._endPickerInputElement,
container:this._endPickerCalendarContainer,
format:this._inputDateFormat,
trigger:this._mainDropdownElement,
onSelect:newEnd=>this._updateCustomEndTime(newEnd),
onClose:()=>this.endPicker.show(),
onDraw:()=>this._highlightCustomIntervalInCalendars()});

}

this._startPickerCalendarElement=this._startPickerCalendarContainer.querySelector('.pika-single');
this._endPickerCalendarElement=this._endPickerCalendarContainer.querySelector('.pika-single');

let onDocumentClicked=()=>this._syncPickerIntervalToSelectedInterval();
$document.on('click',onDocumentClicked);

let onDocumentKeypress=e=>{
if(e.which===13){
this._tryApplyTextBoxEdits();
}
};
$document.on('keypress',onDocumentKeypress);

this._$scope.$on('$destroy',()=>{
this.startPicker.destroy();
this.endPicker.destroy();
$document.off('click',onDocumentClicked);
$document.off('keypress',onDocumentKeypress);
});

this._updateMainButtonLabel();
this._syncPickerIntervalToSelectedInterval();
}

goToNextPeriod(){
this._setIntervalIfChangedAndRefreshPickers(this.interval.shift('days',this.interval.duration.totalDays(),this._localTimeZone));
}

goToPreviousPeriod(){
this._setIntervalIfChangedAndRefreshPickers(this.interval.shift('days',0-this.interval.duration.totalDays(),this._localTimeZone));
}

_refreshPickers(){
this.startPicker.hide();
this.endPicker.hide();

this.startPicker.show();
this.endPicker.show();
}

_findNextValidCalendarDayElementsInInterval(elements,numDaysToTraverse){
let remainingDays=numDaysToTraverse;
let validElementsInInterval=[];
let firstDayFound=!1;

for(let element of elements){
let isValidDay=!Number.isNaN(parseInt(element.getAttribute('data-day'),10));

if(firstDayFound&&isValidDay&&remainingDays>0){
remainingDays--;

validElementsInInterval.push(element);
}

if(this._elementService.hasClass(element,'is-selected')||this._elementService.hasClass(element,'interval-start')||this._elementService.hasClass(element,'interval-end')){
firstDayFound=!0;
}
}

return validElementsInInterval;
}

_removeIntervalClasses(elements){
elements.forEach(element=>{
this._elementService.removeClass(element,'in-interval');
this._elementService.removeClass(element,'interval-start');
this._elementService.removeClass(element,'interval-end');
});
}

_addIntervalClasses(startCalendarElements,endCalendarElements,numDaysToTraverse,visibleStartInterval,visibleEndInterval){
startCalendarElements.forEach(element=>this._elementService.addClass(element,'in-interval'));
endCalendarElements.forEach(element=>this._elementService.addClass(element,'in-interval'));
}

_getVisibleInterval(pikadayContainer){
let visibleMonth=pikadayContainer.getElementsByClassName('pika-select-month')[0].selectedIndex;
let visibleYear=pikadayContainer.getElementsByClassName('pika-select-year')[0].value;
let visibleDate=new Date(visibleYear,visibleMonth,1);

let visibleIntervalPlusOneMs=TimeInterval.from(visibleDate).spanning(1,'month',this._localTimeZone);

return new TimeInterval({
start:visibleIntervalPlusOneMs.start,
end:visibleIntervalPlusOneMs.end-1});

}

_highlightCustomIntervalInCalendars(){
if(!_.allExist([this._startPickerCalendarContainer.getElementsByClassName('pika-select-month')[0],
this._endPickerCalendarContainer.getElementsByClassName('pika-select-month')[0]])){

return;
}

let visibleStartInterval=this._getVisibleInterval(this._startPickerCalendarContainer);
let visibleEndInterval=this._getVisibleInterval(this._endPickerCalendarContainer);

let isCurrentStartMonthEntirelyWithinInterval=visibleStartInterval.start>=this._pickerInterval.start&&
visibleStartInterval.end<=this._pickerInterval.end;

let isCurrentEndMonthEntirelyWithinInterval=visibleEndInterval.start>=this._pickerInterval.start&&
visibleEndInterval.end<=this._pickerInterval.end;

let numDaysToTraverse=this._pickerInterval.expandToRoundTarget('days',this._localTimeZone).
getSpanningIntervals('days',1,this._localTimeZone).length-1;

let startCalendarElements=_.toArray(this._startPickerCalendarContainer.getElementsByTagName(`td`)).
filter(element=>!this._elementService.hasAnyClass(element,['is-empty','is-disabled']));
let endCalendarElements=_.toArray(this._endPickerCalendarContainer.getElementsByTagName(`td`)).reverse().
filter(element=>!this._elementService.hasAnyClass(element,['is-empty','is-disabled']));

this._removeIntervalClasses(startCalendarElements);
this._removeIntervalClasses(endCalendarElements);

let isStartCalendarOnEndMonth=this._pickerInterval.end<=visibleStartInterval.end&&this._pickerInterval.end>=visibleStartInterval.start;
let isEndCalendarOnStartMonth=this._pickerInterval.start<=visibleEndInterval.end&&this._pickerInterval.start>=visibleEndInterval.start;

if(isStartCalendarOnEndMonth){
this._elementService.addClass(_.last(startCalendarElements),'interval-end');
}

if(isEndCalendarOnStartMonth){
this._elementService.addClass(_.last(endCalendarElements),'interval-start');
}

let daysInIntervalInStartCalendar=isCurrentStartMonthEntirelyWithinInterval?
startCalendarElements:
isStartCalendarOnEndMonth?
this._findNextValidCalendarDayElementsInInterval(startCalendarElements.reverse(),numDaysToTraverse):
this._findNextValidCalendarDayElementsInInterval(startCalendarElements,numDaysToTraverse);

let daysInIntervalInEndCalendar=isCurrentEndMonthEntirelyWithinInterval?
endCalendarElements:
isEndCalendarOnStartMonth?
this._findNextValidCalendarDayElementsInInterval(endCalendarElements.reverse(),numDaysToTraverse):
this._findNextValidCalendarDayElementsInInterval(endCalendarElements,numDaysToTraverse);

this._addIntervalClasses(daysInIntervalInStartCalendar,daysInIntervalInEndCalendar,numDaysToTraverse,visibleStartInterval,visibleEndInterval);
}

_updateValidRange(){
this.startPicker.setMaxDate(this._pickerInterval.end);
this.endPicker.setMinDate(this._pickerInterval.start);
this._$timeout(()=>this._refreshPickers());
}

_getFormattedDatesForSelectedInterval(format){
return{
start:moment(this.interval.start).tz(this._localTimeZone).format(format),
end:moment(this.interval.end).tz(this._localTimeZone).format(format)};

}

_updateMainButtonLabel(){
let formattedDates=this._getFormattedDatesForSelectedInterval('MMM DD, YYYY');

let startDateFormat=formattedDates.start;
if(this.interval.start.getFullYear()===this.interval.end.getFullYear()){
startDateFormat=formattedDates.start.split(',')[0];
}

this._elementService.setText(this._mainButtonElement,`${startDateFormat} - ${formattedDates.end}`);
}

_syncPickerIntervalToSelectedInterval(){
let proposedInterval=new TimeInterval(this.interval.start.getTime(),moment(this.interval.end).startOf('day'));
if(_.exists(this._pickerInterval)&&proposedInterval.equals(this._pickerInterval)){
return;
}

this._pickerInterval=proposedInterval;

let formattedDates=this._getFormattedDatesForSelectedInterval(this._inputDateFormat);

if(this._startPickerInputElement.value===formattedDates.start&&
this._endPickerInputElement.value===formattedDates.end){
return;
}

this._startPickerInputElement.value=formattedDates.start;
this._endPickerInputElement.value=formattedDates.end;

this._updateValidRange();

this.startPicker.setDate(this._pickerInterval.start);
this.endPicker.setDate(this._pickerInterval.end);
}

_updateCustomStartTime(newStart){
if(newStart.getTime()===this._pickerInterval.start.getTime())
return;

this._pickerInterval=new TimeInterval(newStart,this._pickerInterval.end);
this._updateValidRange();
}

_updateCustomEndTime(newEnd){
if(newEnd.getTime()===this._pickerInterval.end.getTime())
return;

this._pickerInterval=new TimeInterval(this._pickerInterval.start,newEnd);
this._updateValidRange();
}

_setIntervalIfChangedAndRefreshPickers(interval){
let standardizedInterval=_getStandardizedDisplayInterval(interval);
if(!this.interval.equals(standardizedInterval)){
this.interval=standardizedInterval;
this._updateMainButtonLabel();
}
this._syncPickerIntervalToSelectedInterval();
}

applyProposedChanges(){
this.interval=_getStandardizedDisplayInterval(this._pickerInterval);
this._updateMainButtonLabel();
}

cancelProposedChanges(){
this._syncPickerIntervalToSelectedInterval();
}

_tryApplyTextBoxEdits(){
let proposedStartText=this._startPickerInputElement.value;
let proposedEndText=this._endPickerInputElement.value;

let proposedStartTime=moment(proposedStartText,this._inputDateFormat).valueOf();
let proposedEndTime=moment(proposedEndText,this._inputDateFormat).valueOf();

if(!Number.isNaN(proposedStartTime)&&!Number.isNaN(proposedEndTime)&&proposedStartTime<=proposedEndTime){
this._setIntervalIfChangedAndRefreshPickers(new TimeInterval(proposedStartTime,proposedEndTime));
this._updateValidRange();
}else{
this._syncPickerIntervalToSelectedInterval();
}
}

setToday(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.todayForDisplay)}
setThisWeek(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.thisWeekForDisplay)}
setNextWeek(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.nextWeekForDisplay)}
setLastWeek(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.lastWeekForDisplay)}
setThisMonth(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.thisMonthForDisplay)}
setLastMonth(){this._setIntervalIfChangedAndRefreshPickers(this._intervalService.lastMonthForDisplay)}};


function _getStandardizedDisplayInterval(interval){
return new TimeInterval(interval.start.getTime(),moment(interval.end).startOf('day').endOf('day'));
}let

IntervalPickerDirective=class IntervalPickerDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/directives/intervalPickerDirective/intervalPickerTemplate';
}

get objectBindings(){
return['interval'];
}

get controller(){
return IntervalPickerController;
}};


module.exports=IntervalPickerDirective;
//# sourceMappingURL=intervalPickerDirective.js.map
